import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { AngularFireAuth } from 'angularfire2/auth';
import { ProfileviewPage } from '../profileview/profileview';



@IonicPage()
@Component({
  selector: 'page-popover',
  templateUrl: 'popover.html',
})
export class PopoverPage {


  constructor(public navCtrl: NavController, public navParams: NavParams, private FireAuth: AngularFireAuth,public viewCtrl: ViewController) {
  }

  ionViewDidLoad() {
    ////console.log('ionViewDidLoad PopoverPage');
  }

  logout(){
    this.FireAuth.auth.signOut().then(() => {
      this.viewCtrl.dismiss();
      ////console.log("Cerrar session");
    }).catch(error =>{
      this.viewCtrl.dismiss();
      ////console.log("Error");
    });
  }

  viewProfile(){    
    this.navCtrl.push(ProfileviewPage);
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/popover/popover.ts